<template>
  <v-container fluid fill-width grid-list-sm class="remove-top-padding">
    <v-layout wrap>
      <v-flex xs5>
        <v-card>
          <v-card-text>
            <div>Filter:</div>

            <v-layout wrap>
              <v-flex xs6>
                <v-select
                  :items="$store.state.RequestStatus"
                  label="Request Status"
                  v-model="requestStatus"
                  clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Request ID" v-model="requestId"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Item ID" v-model="itemId"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select :items="$store.state.ECOStatus"
                          label="ECO Status"
                          v-model="ecoStatus"
                          clearable="true"
                ></v-select>
                <!-- @change="ecoStatusChanged()" -->
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="$store.state.FulfillmentStatus"
                  label="Fulfillment Status"
                  v-model="fulfillmentStatus"
                  clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="$store.state.TestingStatus"
                  label="Testing Status"
                  v-model="testingStatus"
                  clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                    :items="$store.state.InvoiceStatus"
                    label="Invoice Status"
                    v-model="invoiceStatus"
                    clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Invoice Number (exact)" v-model="invoiceNumber"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    v-if="!showBulkSerial"
                    label="Serial(s)"
                    v-model="serials"
                    append-icon="fa-expand-arrows-alt"
                    @click:append="toggleSerialsBox"
                ></v-text-field>
                <v-textarea
                    v-if="showBulkSerial"
                    box
                    name="textSerialNumberInput"
                    label="Serial Numbers (One Per Line)"
                    v-model="bulkSerials"
                    append-icon="fa-compress-arrows-alt"
                    @click:append="toggleSerialsBox"
                ></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Sales Order (exact)" v-model="salesOrder"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="RMA Number (exact)" v-model="rmaNumber"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="RMA Tracking (exact)" v-model="rmaTracking"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                    :items="$store.state.RMAReceivedOptions"
                    label="RMA Received"
                    v-model="rmaReceived"
                    clearable="true"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="search" :disabled="isSearchable">Search</v-btn>
            <v-btn @click="clearSearchFilter">Clear Filter</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs2>
        <v-spacer></v-spacer>
      </v-flex>
      <v-flex xs5>
        <v-card>
          <v-card-text>
            <div>Update Values:</div>
            <v-layout wrap>
              <v-flex xs6>
                <v-select
                  :items="$store.state.ECOStatus"
                  label="ECO Status"
                  v-model="updateEcoStatus"
                ></v-select>
                <!-- @change="ecoStatusChanged()" -->
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="$store.state.FulfillmentStatus"
                  label="Fulfillment Status"
                  v-model="updateFulfillmentStatus"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                    :items="$store.state.InvoiceStatus"
                    label="Invoice Status"
                    v-model="updateInvoiceStatus"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Invoice Number" v-model="updateInvoiceNumber"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Tracking" v-model="tracking"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 xlg6>
                <v-menu
                  v-model="menuShipDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="shipDate"
                      label="Ship Date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="shipDate" @input="menuShipDate = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-select
                    :items="$store.state.TestingStatus"
                    label="Testing Status"
                    v-model="updateTestingStatus"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="RMA Number" v-model="updateRMANumber"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                    :items="$store.state.RMAReasonCode"
                    label="RMA Reason"
                    v-model="updateRMAReasonCode"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="RMA Tracking" v-model="updateRMATracking"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                    :items="$store.state.RMAReceivedOptions"
                    label="RMA Received"
                    v-model="updateRMAReceived"
                ></v-select>
              </v-flex>
              <!--v-flex xs6>
                <v-text-field label="Sales Order" v-model="updateSalesOrder"></v-text-field>
              </v-flex-->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-dialog
              v-model="showBulkUpdateConfirmation"
              persistent
              max-width="290"
              class="pad-right"
              >
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" dark v-on="on">Update Selected</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">Changing {{ changeCount() }} Records</v-card-title>
                <v-card-text>Are you sure you would like to make changes to {{ changeCount() }} records?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat @click="cancelBulkUpdate">Cancel</v-btn>
                  <v-btn color="green darken-1" flat @click="proceedBulkUpdate" :disabled="changeCount() < 1">Make Changes</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn @click="clearUpdateValues">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-card>
      <v-data-table
        :headers="serialHeaders"
        :items="searchResults"
        class="elevation-1 spacer overflow-fix"
        item-key="serialNumber"
        select-all
        v-model="selected"
        :loading="$store.state.loading > 0"
        :pagination.sync="pagination"
      >
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

        <template v-slot:items="serialProps">
          <tr>
            <td>
              <v-checkbox v-model="serialProps.selected" primary hide-details></v-checkbox>
            </td>
            <td nowrap><router-link :to="{ name: 'BuybackDetails', params: { id: serialProps.item.requestId } }">{{serialProps.item.requestId}}</router-link></td>
            <td nowrap>{{serialProps.item.itemId}}</td>
            <td nowrap><v-btn flat @click="showSerialEditor(serialProps.item)">{{serialProps.item.serialNumber}}</v-btn></td>
            <td nowrap>{{serialProps.item.dateAdded}}</td>
            <td nowrap>{{serialProps.item.ecoStatus}}</td>
            <td nowrap>{{serialProps.item.fulfillmentStatus}}</td>
            <td nowrap>{{serialProps.item.shipDate}}</td>
            <td nowrap><a :href="getTracking(serialProps.item.tracking)" target="_blank">{{serialProps.item.tracking}}</a></td>
            <td nowrap>{{serialProps.item.testingStatus}}</td>
            <td nowrap>{{serialProps.item.invoiceStatus}}</td>
            <td nowrap>{{serialProps.item.invoiceNumber}}</td>
            <td nowrap>{{serialProps.item.salesOrder}}</td>
            <td nowrap>{{serialProps.item.rmaNumber}}</td>
            <td nowrap>{{serialProps.item.rmaReasonCode}}</td>
            <td nowrap>{{serialProps.item.rmaTracking}}</td>
            <td nowrap>{{serialProps.item.rmaReceived}}</td>

          </tr>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn color="success" @click="exportResults" :disabled="areThereResults">Export</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
        v-model="serialDialog"
        width="500"
    >
      <SerialNumberModal
      :request-id="serialEditRequestId"
      :request-line-id="serialEditRequestLineId"
      v-on:save="saveSerial"
      :existing-serial="serialEditExistingSerialItem"
      :request-item-id="serialEditRequestItemId"
      allow-bulk="false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import http from "../http";
import { baseApiUrl } from "../config";
import { saveAs } from 'file-saver';
import SerialNumberModal from './SerialNumberModal';

export default {
  name: "BuybackRequest",
  data() {
    return {
      serialHeaders: [
        { text: "Request ID", value: "requestId" },
        { text: "Item ID", value: "itemId" },
        { text: "Serial #", value: "serialNumber" },
        { text: "Date Added", value: "serialNumber" },
        { text: "ECO Status", value: "ecoStatus" },
        { text: "Fulfillment Status", value: "fulfillmentStatus" },
        { text: "Ship Date", value: "shipDate" },
        { text: "Tracking", value: "tracking" },
        { text: "Testing Status", value: "testingStatus" },
        { text: "Inv. Status", value: "invoiceStatus" },
        { text: "Inv. Number", value: "invoiceNumber" },
        { text: "Sales Order", value: "salesOrder" },
        { text: "RMA #", value: "rmaNumber" },
        { text: "RMA Reason", value: "rmaReasonCode" },
        { text: "RMA Tracking", value: "rmaTracking" },
        { text: "RMA Received", value: "rmaReceived" },
      ],
      searchResults: undefined,
      menuShipDate: undefined,
      selected: [],

      showBulkSerial: false,
      hasAutoSearched: false,

      // Search Fields
      requestStatus: undefined,
      requestId: undefined,
      itemId: undefined,
      ecoStatus: undefined,
      fulfillmentStatus: undefined,
      testingStatus: undefined,
      serials: undefined,
      bulkSerials: undefined,
      invoiceStatus: undefined,
      invoiceNumber: undefined,
      salesOrder: undefined,
      rmaNumber: undefined,
      rmaReceived: undefined,
      rmaTracking: undefined,

      // updateFields
      shipDate: undefined,
      tracking: undefined,
      selectedItems: [],
      updateEcoStatus: undefined,
      updateTestingStatus: undefined,
      updateFulfillmentStatus: undefined,
      updateInvoiceStatus: undefined,
      updateInvoiceNumber: undefined,
      updateSalesOrder: undefined,
      updateRMANumber: undefined,
      updateRMAReasonCode: undefined,
      updateRMAReceived: undefined,
      updateRMATracking: undefined,

      pagination: {
        rowsPerPage: 25,
      },

      // serial modal fields
      serialEditRequestId: undefined,
      serialEditRequestLineId: undefined,
      serialEditExistingSerialItem: undefined,
      serialEditRequestItemId: undefined,
      serialDialog: false,

      showBulkUpdateConfirmation: false,
    };
  },
  components: {
      SerialNumberModal,
  },
  computed: {
    areThereResults() {
      if (this.searchResults && this.searchResults.length > 0) return false;
      return true;
    },
    isSearchable: function() {
      const searchable =
        this.requestStatus ||
        this.requestId ||
        this.itemId ||
        this.ecoStatus ||
        this.fulfillmentStatus ||
        this.testingStatus ||
        this.bulkSerials ||
        this.serials ||
        this.invoiceStatus ||
        this.invoiceNumber ||
        this.salesOrder ||
        this.rmaNumber ||
        this.rmaTracking ||
        this.rmaReceived ||
        false;
      console.log("searchable:", !searchable);

      return !searchable;
    },

  },
  methods: {
    isUpdateDisabled: function() {
      return (
        this.selected.length === 0 ||
        (!this.shipDate &&
          !this.tracking &&
          !this.updateEcoStatus &&
          !this.updateTestingStatus &&
          !this.updateInvoiceStatus &&
          !this.updateInvoiceNumber &&
          !this.updateSalesOrder &&
          !this.updateFulfillmentStatus &&
          !this.updateRMAReceived &&
          !this.updateRMATracking &&
          !this.updateRMAReceived &&
          !this.updateRMAReasonCode
        )
      );
    },

    changeCount() {
      return this.selected.length;
    },
    cancelBulkUpdate() {
      this.showBulkUpdateConfirmation = false;
    },
    proceedBulkUpdate() {
      this.showBulkUpdateConfirmation = false;
      this.updateSelected();
    },
    toggleSerialsBox() {
      console.log('toggle it');
      this.showBulkSerial = !this.showBulkSerial;
    },
    showSerialEditor(item) {
      console.log('showSerialEditor:', item);
      this.serialEditRequestId = item.requestId;
      this.serialEditRequestLineId = item.requestLineId;
      this.serialEditExistingSerialItem = item;
      this.serialEditRequestItemId = item.itemId;
      this.serialDialog = true;
    },
    async saveSerial(updatedSerial) {
      console.log('saveSerial - updatedSerial:', updatedSerial);

      this.serialDialog = false;

      console.log('updatedSerial Data:', updatedSerial, updatedSerial.requestLineId);
      await http.put(`${baseApiUrl}/request/serial/${this.serialEditRequestId}/${this.serialEditRequestLineId}`, updatedSerial);

      this.serialEditRequestId = undefined;
      this.serialEditRequestLineId = undefined;
      this.serialEditExistingSerialItem = undefined;
      this.serialEditRequestItemId = undefined;

      await this.search();
    },
    getTracking(trackingNumber) {
      if (!trackingNumber) return '';
      if (!trackingNumber.indexOf('4') === 0) return '';

      return `https://www.fedex.com/apps/fedextrack/?tracknumbers=${trackingNumber}`;
    },
    exportResults() {
      // get headers
      // RequestID, Item ID, Serial Number, Date Added, ECO Status, Fulfillment Status, Testing Status
      const headers = `"RequestID","Item ID","Serial Number","Date Added","ECO Status","Fulfillment Status","Testing Status","Invoice Status","Invoice Number","Sales Order","Price","Tracking","Ship Date","RMA Number","RMA Reason","RMA Tracking","RMA Received"`;
      const lines = [headers];

      console.log('searchResults:', this.searchResults);

      // build lines
      for(let line of this.searchResults) {
        lines.push(`"${line.requestId}","${line.itemId.replace('"', '""')}","${line.serialNumber.replace('"', '""')}","${line.dateAdded}","${line.ecoStatus || ''}","${line.fulfillmentStatus || ''}","${line.testingStatus || ''}","${line.invoiceStatus || ''}","${line.invoiceNumber || ''}","${line.salesOrder || ''}","${line.price || ''}","${line.tracking || ''}","${line.shipDate || ''}","${line.rmaNumber || ''}","${line.rmaReasonCode || ''}","${line.rmaTracking || ''}","${line.rmaReceived || ''}"`);
      }

      // download
      const blob = new Blob([lines.join('\n')], {type: "text/plain;charset=utf-8"});
      saveAs(blob, "serial-export.csv");
    },
    clearSearchFilter() {
      this.requestStatus = undefined;
      this.requestId = undefined;
      this.itemId = undefined;
      this.ecoStatus = undefined;
      this.fulfillmentStatus = undefined;
      this.testingStatus = undefined;
      this.serials = undefined;
      this.invoiceStatus = undefined;
      this.invoiceNumber = undefined;
      this.salesOrder = undefined;
      this.rmaNumber = undefined;
      this.rmaReasonCode = undefined;
      this.rmaTracking = undefined;
    },
    clearUpdateValues() {
      this.shipDate = undefined;
      this.tracking = undefined;
      this.updateEcoStatus = undefined;
      this.updateTestingStatus = undefined;
      this.updateFulfillmentStatus = undefined;
      this.updateInvoiceNumber = undefined;
      this.updateInvoiceStatus = undefined;
      this.updateSalesOrder = undefined;
      this.updateRMANumber = undefined;
      this.updateRMAReasonCode = undefined;
      this.updateRMATracking = undefined;
      this.updateRMAReceived = undefined;
    },
    async search() {
      console.log("search called.");
      const results = await http.get(
        `${baseApiUrl}/search/serial?${this.formatQueryString()}`
      );
      console.log("results.data:", results.data);

      this.searchResults = results.data;
    },

    formatQueryString() {
      let serials;
      if (this.bulkSerials) {
          serials = this.bulkSerials
            .split('\n')
            .map(bs => bs.trim())
            .join(',');
      } else {
        serials = this.serials;
      }

      const parameters = {
        requestStatus: this.requestStatus,
        requestId: this.requestId,
        itemId: this.itemId,
        ecoStatus: this.ecoStatus,
        fulfillmentStatus: this.fulfillmentStatus,
        testingStatus: this.testingStatus,
        invoiceStatus: this.invoiceStatus,
        invoiceNumber: this.invoiceNumber,
        salesOrder: this.salesOrder,
        serials,
        rmaNumber: this.rmaNumber,
        rmaTracking: this.rmaTracking,
        rmaReceived: this.rmaReceived,
      };

      let queryString = "";
      for (let key of Object.keys(parameters)) {
        if (parameters[key]) {
          queryString += `&${key}=${encodeURIComponent(parameters[key])}`;
        }
      }

      if (queryString.length > 0) {
        queryString = queryString.substring(1);
      }

      return queryString;
    },
    async updateSelected() {
      const updateRequest = {
        serialLines: this.selected.map(row => {
          return {
            requestId: row.requestId,
            requestLineId: row.requestLineId,
            serialNumber: row.serialNumber
          };
        }),
        ecoStatus: this.updateEcoStatus === '<Empty>' ? null : this.updateEcoStatus,
        fulfillmentStatus: this.updateFulfillmentStatus === '<Empty>' ? null : this.updateFulfillmentStatus,
        testingStatus: this.updateTestingStatus === '<Empty>' ? null : this.updateTestingStatus,
        tracking: this.tracking,
        shipDate: this.shipDate,
        invoiceStatus: this.updateInvoiceStatus === '<Empty>' ? null : this.updateInvoiceStatus,
        invoiceNumber: this.updateInvoiceNumber,
        salesOrder: this.updateSalesOrder,
        rmaNumber: this.updateRMANumber,
        rmaReasonCode: this.updateRMAReasonCode,
        rmaTracking: this.updateRMATracking,
        rmaReceived: this.updateRMAReceived,
      };

      if (this.updateTestingStatus &&
        this.updateTestingStatus === 'Pass' &&
        !this.updateInvoiceStatus
      ) {
        updateRequest.invoiceStatus = 'Pending';
      }

      if (this.updateEcoStatus) {
        updateRequest.ecoDate = this.formatDate(new Date());
      }

      await http.post(`${baseApiUrl}/serial/bulk`, updateRequest);
      this.clearUpdateValues();
      await this.search();
    },
    formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    }
  },
  beforeCreate() {
    console.log('BC: ecoStatus:', this.ecoStatus);
  },

  beforeUpdate() {
    if (!this.$router.currentRoute.query) return;
    let searchChanged = false;

    if (this.$router.currentRoute.query.ecoStatus) {
      this.ecoStatus = this.$router.currentRoute.query.ecoStatus;
      console.log('set ecoStatus');
      searchChanged = true;
    }

    if (this.$router.currentRoute.query.testingStatus) {
      this.testingStatus = this.$router.currentRoute.query.testingStatus;
      console.log('set testingStatus');
      searchChanged = true;
    }

    if (this.$router.currentRoute.query.requestStatus) {
      this.requestStatus = this.$router.currentRoute.query.requestStatus;
      console.log('set requestStatus');
      searchChanged = true;
    }

    if (this.$router.currentRoute.query.invoiceStatus) {
      this.invoiceStatus = this.$router.currentRoute.query.invoiceStatus;
      console.log('set invoiceStatus');
      searchChanged = true;
    }

    if (!this.hasAutoSearched && searchChanged) {
      this.hasAutoSearched = true;
      this.search();
    }
  },

  mounted() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'Serial Updates / Search', disabled: true },
    ]);
  },
};
</script>

<style>
  .remove-top-padding {
    padding-top: 0px;
    padding-bottom: 24px;
    padding-left: 24px;
    padding-right: 24px;
  }

  .spacer {
    margin-top: 12px;
  }

  .pad-right {
    margin-right: 12px;
  }

  .overflow-fix {
    overflow-x: auto !important;
  }
</style>
